import {
  LIST_ABILITIES_BY_USER_AND_GROUP,
  LIST_ABILITIES_BY_USER_AND_GROUP_SUCCESS,
  LIST_ABILITIES_BY_USER_AND_GROUP_CLEAN,
  LIST_ABILITIES_BY_USER_AND_GROUP_ERROR,
} from "./actionTypes"

const initialState = {
  error: "",
  loading: false,
  done: false,
  abilities: [],
}

const AbilitiesList = (state = initialState, action) => {
  switch (action.type) {
    case LIST_ABILITIES_BY_USER_AND_GROUP:
      state = {
        ...state,
        loading: true,
      }
      break
    case LIST_ABILITIES_BY_USER_AND_GROUP_SUCCESS:
      state = {
        ...state,
        abilities: action.payload.abilities,
        loading: false,
        done: true,
      }
      break
    case LIST_ABILITIES_BY_USER_AND_GROUP_CLEAN:
      state = initialState
      break
    case LIST_ABILITIES_BY_USER_AND_GROUP_ERROR:
      state = {
        ...state,
        error: action.payload,
        loading: false,
        done: false,
        abilities: [],
      }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default AbilitiesList
